.disabled-link{pointer-events:none;opacity:.5;cursor:default}.mat-mdc-form-field{display:block}
/*# sourceMappingURL=user-sign-in.component-4GSSXCBJ.css.map */
